import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Holiday } from 'src/app/model/holiday';
import { HolidayProvider } from '../../../providers';

@Component({
  selector: 'app-create-edit-holiday',
  templateUrl: './create-edit-holiday.modal.html',
  styleUrls: ['./create-edit-holiday.modal.scss']
})
export class CreateEditHolidayModal implements OnInit, OnDestroy {
  subject: Subject<Holiday>;
  subscription: any;
  isEdit = false;
  holiday: Holiday = new Holiday();
  saving = false;

  months = [
    { v: 1, n: 'January' }, { v: 2, n: 'February' }, { v: 3, n: 'March' },
    { v: 4, n: 'April' }, { v: 5, n: 'May' }, { v: 6, n: 'June' },
    { v: 7, n: 'July' }, { v: 8, n: 'August' }, { v: 9, n: 'September' },
    { v: 10, n: 'October' }, { v: 11, n: 'November' }, { v: 12, n: 'December' }
  ];
  weeks = [
    { v: 1, n: '1st' }, { v: 2, n: '2nd' }, { v: 3, n: '3rd' },
    { v: 4, n: '4th' }, { v: -1, n: 'Last' }
  ];
  weekdays = [
    { v: 1, n: 'Monday' }, { v: 2, n: 'Tuesday' }, { v: 3, n: 'Wednesday' },
    { v: 4, n: 'Thursday' }, { v: 5, n: 'Friday' }, { v: 6, n: 'Saturday' }, { v: 7, n: 'Sunday' }
  ];

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private holidayProvider: HolidayProvider
  ) { }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onConfirm(holiday: Holiday): void {
    this.bsModalRef.hide();
    this.subject.next(holiday);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  onSubmit(): void {
    this.saving = true;
    this.holidayProvider.saveHoliday(this.holiday).subscribe(data => {
      this.saving = false;
      if (data.success) this.onConfirm(Holiday.parse(data.result));
    }, () => this.saving = false);
  }
}
